import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import SelectNew from './SelectNew';
import { translate } from '../../utils/util';
import ConfigurationService from '../../services/ConfigurationService';
import { getVision } from '../../services/auth';
import { VISIONS } from '../../utils/constants';
import LinePickingService from '../../services/LinePickingService';
import SecurityService from '../../services/SecurityService';

const SelectEquipmentUI = (props) => {
    const [equipments, setEquipments] = useState([]);

    useEffect(() => {
        if ((!props.equipments?.items || props.equipments?.items <= 0) && (getVision() === VISIONS.Fiasa || getVision() === VISIONS.Faasa || getVision() === VISIONS.FaasaCKD)) {
            props.getEquipments(props.user.vision, {});
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (props.equipments?.items) {
            setEquipments([...props.equipments?.items]);
            setSector(props.value);
        }
        // eslint-disable-next-line
    }, [props.equipments?.items, props.value]);

    const setSector = (value) => {
        let equipmentFilter = props.equipments?.items.find((i) => i.equipmentId === parseInt(value || 0));
        let sectors = equipmentFilter ? equipmentFilter.sector.split(';') : '';
        props.setSectors(sectors);
        if (equipmentFilter) {
            props.setEquipment(equipmentFilter.equipmentId, equipmentFilter);
        }
    }
    const onChange = (evt) => {
        setSector(evt.target.value);
        if (props.onChange) {
            props.onChange(evt);
        }
    }

    return (
        <SelectNew
            required={props.required}
            id={props.id || 'equipment'}
            name={props.id || 'equipment'}
            valuefield="equipmentId"
            label={translate('title', 'equipment')}
            placeHolder={translate('general:choose-one-option')}
            value={props.value}
            data={equipments.map((i) => { return { id: i.equipmentId, text: i.code }; })}
            change={onChange}
        />
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        equipments: state.configReducer.equipments
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getEquipments: (vision, filter) => {
            dispatch(ConfigurationService.getEquipments(vision, filter));
        },
        setSectors: (sectors) => {
            dispatch(LinePickingService.setSectors(sectors));
        },
        setEquipment: (equipmentId, obj) => {
            dispatch(SecurityService.setEquipment(equipmentId, obj));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SelectEquipmentUI));
